
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { BannerComponent } from './banner.component';




@NgModule({
  declarations: [BannerComponent],
  imports: [CommonModule, LazyLoadImageModule],
  exports: [BannerComponent] // Exporta o componente para ser usado em outros módulos
})
export class BannerModule { }
